import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationJA from './locales/ja/translation.json'
import translationEN from './locales/en/translation.json'

const resources = {
  ja: {
    translation: translationJA,
  },
  en: {
    translation: translationEN,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja', // Default to Japanese
    supportedLngs: ['en', 'ja'],
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // the choice made on this device, else the device's own first language: English only when that is English
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: (l: string) => (l.toLowerCase().startsWith('en') ? 'en' : 'ja'),
    },
  })

export default i18n
